import React, { useContext } from 'react'
import { HightLight, Text } from '../gameRulesStyle'
import { ReactComponent as DiceSVG } from '../../../lib/assets/dices.svg'
import { MyContext } from '../../../context/createContext'

export default function About() {
  const { context } = useContext(MyContext)
  const {
    config,
    auth: {
      balance: { currency },
    },
  } = context
  const { rake, maxbet, minbet } = config

  return (
    <>
      <HightLight fontSize={'22px'} background={'blue'} margin={'15px 0'}>
        About Game
      </HightLight>
      <Text margin={'5px 0'}>
        The dice is rolled
        <DiceSVG />
        in the range of numbers between:
      </Text>
      <Text margin={'10px 0'}>
        <span>0.00</span> and <span>100.00</span>.
        <br />
        <span>0</span> to <span>100</span> is the range, but the bet could be
        placed:
        <br />
        from <span>5.00</span> to <span>96.00</span>
      </Text>
      <Text margin={'5px 0'}>
        The Player’s objective is to guess if the selected number will be
        <span> greater</span> or <span>smaller</span> than the numbers of chosen
        range.
      </Text>
      <Text margin={'5px 0'}>
        <span>Win Calculation:</span> Roll the dice to win your CURRENT BET
        AMOUNT x MULTIPLIER.
      </Text>
      <Text margin={'5px 0'}>
        {/* The overall theoretical return to player <span>(RTP)</span> is{' '}
        <span> 98.15% - 98.98%</span>. */}
        <span>RTP</span> for the Game is <span>98.15% - 98.98%</span>. The
        Maximum <span>RTP</span> can be achieved by the player when opting for
        the multiplier <span>1.4</span>.
      </Text>
      <Text margin={'5px 0'}>Malfunction voids all pays and plays.</Text>
      <Text margin={'5px 0'}>
        Min bet is{' '}
        <span>
          {currency} {minbet}
        </span>
      </Text>
      <Text margin={'5px 0'}>
        Max bet is{' '}
        <span>
          {currency} {maxbet}
        </span>
      </Text>
      <Text margin={'5px 0'}>
        Max multiplier is <span>24.50x</span>
      </Text>
      <Text margin={'5px 0'}>
        {/* Max win is{' '}
        <span>
          {currency}
          {24.62 * maxbet}
        </span> */}
        The <span>max win</span> can be calculated by multiplying the max bet
        with max multiplier.
      </Text>
    </>
  )
}
